export default ()=> {
	const customerLink = document.querySelectorAll(".header__customer-link"),
		areaPopup = document.querySelector(".header__area-popup");


	if (!customerLink) return;

	customerLink.forEach(item => {
		item.addEventListener('click', function (e) {
			e.preventDefault();
			this.classList.toggle('active');
			areaPopup.classList.toggle('active');
		})
	})

	document.addEventListener(
		"click",
		function(event) {
			if (
				!event.target.closest(".header__area-popup") && !event.target.matches(".header__customer-link")
			) {
				closeModal()
			}
		},
		false
	)

	function closeModal() {
		areaPopup.classList.remove('active');
		customerLink.forEach(item => {
			item.classList.remove('active');
		})
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/customer-area.js